/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Hero_SubInputs */

const en_mk_hero_sub = /** @type {(inputs: Mk_Hero_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build with your teammates and their own AI, or orchestrate agent teams in the cloud or on your computer. Share plans, tasks, evidence and reviews in one workspace.`)
};

const id_mk_hero_sub = /** @type {(inputs: Mk_Hero_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build bersama rekan dengan AI masing-masing, atau jalankan tim agent di cloud maupun komputer sendiri. Satukan rencana, tugas, bukti, dan review dalam satu workspace.`)
};

/**
* | output |
* | --- |
* | "Build with your teammates and their own AI, or orchestrate agent teams in the cloud or on your computer. Share plans, tasks, evidence and reviews in one work..." |
*
* @param {Mk_Hero_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_hero_sub = /** @type {((inputs?: Mk_Hero_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Hero_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_hero_sub(inputs)
	return en_mk_hero_sub(inputs)
});